import { createFileRoute } from '@tanstack/react-router'

import { RunsPage } from '@/features/testing/testing-pages'

export const Route = createFileRoute('/runs')({ component: RunsPage })
